import { ConsentedPolicyEnum } from "@/core/constants";
import type { ConsentPayloadDTO, PolicyConsentDTO } from "@/core/types";
import type { PolicyMetaData, ConsentedPolicy, ConsentedPolicyKey } from "@/core/types";
import type { UUID } from "@/core/types";

type ConsentPayloadProps = {
  consent: PolicyConsentDTO;
  consentType: ConsentedPolicy;
  patientId: UUID;
  policyMetadata: PolicyMetaData;
};

export function createConsentPayloadTyped({
  consent,
  consentType,
  patientId,
  policyMetadata,
}: ConsentPayloadProps): ConsentPayloadDTO {
  return {
    consent,
    consent_type: consentType,
    implied_consent_policy_versions: mapPolicyVersions(policyMetadata),
    target_patient_id: patientId,
  };
}

function mapPolicyVersions(policyMetadata: PolicyMetaData): Record<ConsentedPolicy, string> {
  return Object.entries(policyMetadata).reduce(
    (versionMap, [policyKey, policyData]) => {
      const consentType = ConsentedPolicyEnum[policyKey as ConsentedPolicyKey];

      versionMap[consentType] = policyData.current_version;

      return versionMap;
    },
    {} as Record<ConsentedPolicy, string>,
  );
}
